import { Component, OnInit, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { AccessType } from '@icullen/api/shared';


@Component({
  selector: 'icullen-subscription-info',
  templateUrl: './subscription-info.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./subscription-info.component.scss']
})
export class SubscriptionInfoComponent implements OnInit {

  @Input() accessType : AccessType;
  @Input() partialAuth : boolean;

  constructor() { }

  ngOnInit(): void {
  }

  hasFullAccess(){
    return this.accessType === AccessType.FULL_ACCESS;
  }

}
